import { I18n } from '@calendly/i18n'

import {
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_INVITEE_NO_SHOW,
  BOOKING_BEFORE_MEETING_STARTED,
  BOOKING_WHEN_MEETING_CANCELED,
  BOOKING_WHEN_MEETING_FINISHED,
  BOOKING_WHEN_MEETING_RESCHEDULED,
  BOOKING_WHEN_MEETING_SCHEDULED,
  BOOKING_WHEN_MEETING_STARTED, UNITS_DAYS, UNITS_HOURS, UNITS_MINUTES
} from './modals/controls/trigger_edit/consts'

const inviteeBookedI18n = {
  when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.when_this_happens'),
  how_long: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.how_long'),
  immediately: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.immediately'),
  timing: {
    [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.timing.days', params),
    [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.timing.hours', params),
    [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.timing.minutes', params)
  }
}

const i18nMap = {
  [BOOKING_WHEN_INVITEE_BOOKED]: inviteeBookedI18n,
  [BOOKING_WHEN_MEETING_SCHEDULED]: inviteeBookedI18n,
  [BOOKING_BEFORE_MEETING_STARTED]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.before.meeting_started.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.before.meeting_started.how_long'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.before.meeting_started.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.before.meeting_started.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.before.meeting_started.timing.minutes', params)
    }
  },
  [BOOKING_WHEN_MEETING_STARTED]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.how_long'),
    immediately: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.immediately'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_started.timing.minutes', params)
    }
  },
  [BOOKING_WHEN_MEETING_FINISHED]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.how_long'),
    immediately: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.immediately'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_finished.timing.minutes', params)
    }
  },
  [BOOKING_WHEN_MEETING_CANCELED]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.how_long'),
    immediately: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.immediately'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_canceled.timing.minutes', params)
    }
  },
  [BOOKING_WHEN_MEETING_RESCHEDULED]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.how_long'),
    immediately: () => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.immediately'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.meeting_rescheduled.timing.minutes', params)
    }
  },
  [BOOKING_WHEN_INVITEE_NO_SHOW]: {
    when_this_happens: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.when_this_happens'),
    how_long: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.how_long'),
    immediately: () => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.immediately'),
    timing: {
      [UNITS_DAYS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.timing.days', params),
      [UNITS_HOURS]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.timing.hours', params),
      [UNITS_MINUTES]: (params) => I18n.t('publisher.workflows.triggers.booking.when.invitee_no_show.timing.minutes', params)
    }
  }
}

export const whenThisHappensText = (type) => i18nMap[type].when_this_happens()
export const howLongText = (type) => i18nMap[type].how_long()

const triggerTitleImmediatelyText = (type) => i18nMap[type].immediately()

const triggerTitleWithTimingText = (type, { timeValue, timeUnits }) => {
  const i18nParams = { count: timeValue }
  const timeUnitI18nFunc = i18nMap[type].timing[timeUnits]
  return timeUnitI18nFunc(i18nParams)
}

export const triggerTitleText = (workflowType, rule) => {
  const triggerType = rule.triggerType || rule.trigger_type
  const eventName = rule.eventName || rule.event_name
  const timeValue = rule.timeValue || rule.time_value
  const timeUnits = rule.timeUnits || rule.time_units

  const type = `${workflowType}.${triggerType}.${eventName}`

  if (timeValue === null || timeValue === 0 || timeValue === undefined) {
    return triggerTitleImmediatelyText(type)
  }

  return triggerTitleWithTimingText(type, { timeValue, timeUnits })
}
